import { BaseRequestModel } from '../../../base/base.request.model';

export class LogOutUserRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  LogOutUserRequestMessage!: BaseRequestModel;
}
